import { render, staticRenderFns } from "./previousDonations.vue?vue&type=template&id=ab88289c&scoped=true"
import script from "./previousDonations.vue?vue&type=script&lang=js"
export * from "./previousDonations.vue?vue&type=script&lang=js"
import style0 from "./previousDonations.vue?vue&type=style&index=0&id=ab88289c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab88289c",
  null
  
)

export default component.exports